@if (isVisible()) {
  <xi-popout
    [isVisible]="isVisible()"
    [anchorElement]="element()"
    [internalPadding]="internalPadding()"
    [containedPopoutIds]="containedPopoutIdsSignal()"
    (onExternalPress)="onClose()"
    (onEscape)="onClose()"
  >
    <div slot="children">
      <ng-container [ngTemplateOutlet]="content.templateRef"></ng-container>
    </div>
  </xi-popout>
}
